class TimeoutCountdownController {
  /*@ngInject*/
  constructor($translate, UsersService, Modal, $scope, User, Auth, $state, $interval, Idle) {
    this.$translate = $translate;
    this.UsersService = UsersService;
    this.Auth = Auth;
    this.$scope = $scope;
    this.Modal = Modal;
    this.User = User;
    this.$state = $state;
    this.$interval = $interval;
    this.Idle = Idle;
    this.countdown = 0;
  }

  $onInit() {
    const timeout = this.Idle.getTimeout() || 10;
    this.updateCountdown(timeout);

    this.$scope.$on('IdleWarn', (event, countdown) => {
      this.$scope.$evalAsync(() => {
        this.updateCountdown(countdown);
      });
    });

    this.$scope.$on('IdleTimeout', () => {
      this.$scope.$evalAsync(() => {
        this.updateCountdown(0);
      });
    });
  }

  updateCountdown(countdown) {
    this.countdown = countdown;
    const hours = Math.floor(this.countdown / 3600);
    const minutes = Math.floor((this.countdown % 3600) / 60);
    const seconds = this.countdown % 60;
    this.countdownDisplay = `${this.padZero(hours)}:${this.padZero(minutes)}:${this.padZero(seconds)}`;
    this.message = this.$translate.instant('countdown.message', {
      countdown: this.countdownDisplay
    });
  }

  padZero(value) {
    return value.toString().padStart(2, '0');
  }

  logout() {
    if(!this.Auth.isAuthenticated()){
      this.Auth.logout();
      this.$state.go('login')
      localStorage.removeItem('sessionLength')
    }
  }
}

export default TimeoutCountdownController;



// WEBPACK FOOTER //
// ./client/app/common/ui/timeoutCountdown/timeoutCountdown.controller.js